$(function(){
	var videoInputEls = $('.form-media__video input[type=text]');

	// get youtube video from link
	videoInputEls.on('change', function(){
		getInputVideo(this);
	});

	// get video links on load
	for(var i = 0; i < videoInputEls.length; i++) getInputVideo(videoInputEls[i]);

	// get youtube video from input link
	function getInputVideo(inputEl){
		var inputEl 			= $(inputEl);
		var wrapperEl 		= inputEl.closest('.form-media__video');
		var hiddenInputEl = wrapperEl.find('input[type=hidden]');
		var iframeEl      = wrapperEl.find('iframe');
		var previewEl 		= wrapperEl.find('.form__video');

		// extract videoId from url
		var videoId = extractYoutubeVideoID(inputEl.val());
		if(videoId) {
			previewEl.addClass('active');
			iframeEl.attr('src', 'https://www.youtube.com/embed/' + videoId);
			hiddenInputEl.val('https://www.youtube.com/embed/' + videoId);
		}
		else {
			previewEl.removeClass('active');
			iframeEl.attr('src', '');
			hiddenInputEl.val('');

			console.log('Could not extract youtube video');
		}
	}
});

function extractYoutubeVideoID(url){
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);

  // if there is id
  if ( match && match[7].length == 11 ){
    return match[7];
  }
  else {
    return null;
  }
}